import React from 'react';
import PageTemplate from 'components/common/PageTemplate';
import QnaBoard from 'view/qnaBoard';

const QnaBoardPage = () => {
	return (
		<PageTemplate>
			<QnaBoard /> 
		</PageTemplate>
	);
};

export default QnaBoardPage;

 